export default __webpack_public_path__ + "static/media/Censer of Those Who Wait Below.2032caea.jpg";